import { createSlice } from '@reduxjs/toolkit';
import {
  fetchCandidates,
  searchCandidateOptions,
  fetchById,
  fetchTagsOptions,
  fetchCandidatesCampaignById,
  updateChannel,
  fetchAllTemplates,
  fetchICIMSData,
  addCandidate,
  updateCandidate,
  resetCandidateSave,
  fetchCandidateScheduledMessages,
  candidatesUpload,
  updateInactiveCandidate,
  updateArchiveCandidate,
  updateStarredCandidate,
  updateAllActiveCandidate,
  updateDoNotTextCandidate,
  updateDoNotTextFlag,
  resetCandidateUpdatedFlag,
  validateCandidate,
  fetchNumberCandidatesWithTags,
  candidatesImport,
  fetchCandidateMetricsById,
  deleteCandidateTag,
  addTagForCandidate,
  removeSelectedCampaign,
  resetImportModalSuccessFlag,
  fetchOmniSearch,
  deleteCandidatesAction,
  cancelScheduledMessages,
  resetIsCancelMessageSuccess,
  fetchCandidatesInSequence,
  fetchATSCandidates,
  addATSCandidate,
  addAtsCandidateSuccess,
  updateAtsCandidateSavedStatus,
  setCandidateSaved,
  resetIsError,
  resetCandidateUpdated,
  resetCandidateOptions,
  resetTagsOptions,
  fetchBackgroundEvents,
} from '../actions';
import {
  CandidateSource,
  channelTypes,
  productTypes,
  candidateStatusTypes,
  phoneValidationStatus,
  backgroundEventTypes,
} from 'appConstants';
import { dedupeOptions } from 'util/helpers';
import { commonStateUpdates } from 'redux/reducers/commonStateUpdate';

const { ICIMS, NEXXT, RESTRICTED } = CandidateSource;
const textrecruit = productTypes.TEXT_RECRUIT.toLowerCase();
const resubscribeMesssage = 'resubscribe';

const initialState = {
  isLoading: true,
  candidateWithTagsLoading: false,
  candidatesNumberWithTags: 0,
  savingCandidate: false,
  candidateSaved: false,
  candidateUpdated: false,
  atsCandidateSaved: false,
  page: 1,
  candidateStatusUpdated: false,
  starredCandidateUpdated: false,
  doNotText: false,
  candidatesCount: 0,
  atsCandidatesCount: 0,
  selectedAtsIdsCount: 0,
  added: 0,
  candidates: [],
  availableChannels: [],
  scheduledMessages: {
    messages: [],
    isLoading: false,
    count: 0,
    page: 1,
  },
  phone: {
    status: phoneValidationStatus.UNCONFIRMED,
  },
  fullTags: [],
  candidateValidationLoading: false,
  tagsOptions: [],
  tagsOptionsPage: 1,
  tagsOptionsCount: 0,
  isTagsOptionsLoading: false,
  candidateOptions: [],
  isCandidateOptionsLoading: false,
  candidateOptionsCount: 0,
  candidateCampaign: {
    campaigns: [],
    isLoading: false,
    campaignsCount: 0,
  },
  candidateMetrics: {},
  candidateMetricsLoading: false,
  candidateTagsUpdating: false,
  candidateDeleteUpdating: false,
  status: candidateStatusTypes.ACTIVE,
  defaultChannel: channelTypes.SMS,
  isChannelUpdating: false,
  candidateCampaignUpdating: false,
  // ICIMS specific
  loadingICIMSData: false,
  icimsIntegrationData: {},

  // templates
  loadingTemplates: true,
  hasTemplates: false,
  teamTemplates: [],
  userTemplates: [],
  whatsAppTemplates: [],
  candidatesPerTag: [],

  // candidates file upload
  candidatesUpload: {
    isLoading: false,
    uploadHeaders: [],
    rowCount: 0,
    isError: false,
    isUploaded: false,
    isImportSuccess: false,
  },

  omniSearchList: [],
  omniSearchLoading: false,
  candidatesInSequence: [],
  candidatesInSequenceLoading: false,

  // Cancel/Stop Scheduled Messages

  isCancelMessage: false,
  isCancelMessageSuccess: false,
  candidateByIdError: false,
};

const updateCandidateLoop = (candidates) =>
  candidates.map((candidate) => ({
    ...candidate,
    fullName: candidate.fullName || '',
    phoneNumber: candidate.phoneNumber || '',
    created: candidate.created || '',
    fullTags: candidate.fullTags || [],
    tags: candidate.tags || [],
    jobTitle: candidate.jobTitle || '',
  }));

export const getSource = (source) => source || '';

export const getSourceId = (sourceId) => sourceId || '';

export const checkValidation = (phoneValidation) => (phoneValidation ? phoneValidation : false);

/* eslint-disable complexity */
const setCandidate = (state, candidateData) => {
  const candidateChannels = candidateData.availableChannels || [channelTypes.SMS];
  state.id = candidateData.id;
  state.status = candidateData.status;
  state.firstName = candidateData.firstName;
  state.lastName = candidateData.source === NEXXT ? RESTRICTED : candidateData.lastName;
  state.phoneNumber = candidateData.source === NEXXT ? RESTRICTED : candidateData.phoneNumber;

  // next line is deprecated and should be removed when safe. -Amir
  state.phone.number = candidateData.source === NEXXT ? RESTRICTED : candidateData.phoneNumber;
  state.jobTitle = candidateData.jobTitle || '';
  state.defaultChannel = candidateData.channel || channelTypes.SMS;
  state.availableChannels = candidateChannels.filter((c) =>
    [
      channelTypes.SMS,
      channelTypes.WHATS_APP,
      channelTypes.FACEBOOK_MESSENGER,
      channelTypes.WECHAT,
    ].includes(c),
  );
  state.doNotText = Boolean(candidateData.doNotText);
  state.jobs = (candidateData.jobs || []).slice().reverse();
  state.userName = candidateData.userName;
  state.fullTags = candidateData.fullTags || [];
  state.source = getSource(candidateData.source);
  state.sourceId = getSourceId(candidateData.sourceId);
  state.optedIn =
    // eslint-disable-next-line no-undefined
    candidateData.optedIn === undefined ? true : candidateData.optedIn;
  state.candidatePhoneValidation = checkValidation(candidateData.validation);
  state.phoneValidation = candidateData.validation;

  // TODO: deprecate below code when safe. -Amir
  if (candidateData.validation) {
    state.phone.formatted = candidateData.validation.formatNational;
    state.phone.regionCode = candidateData.validation.regionCode;
    state.phone.isValid = candidateData.validation.isValid;
    state.phone.carrier = candidateData.validation.carrier;
    state.phone.lineType = candidateData.validation.lineType;
    state.phone.status = candidateData.validation.status;
  }
};

const resetCandidate = (state) => {
  state.id = null;
  state.status = 'active';
  state.firstName = null;
  state.lastName = null;
  state.phone = {};
  state.jobTitle = null;
  state.defaultChannel = 'sms';
  state.availableChannels = [];
  state.doNotText = false;
  state.jobs = [];
  state.userName = null;
  state.optedIn = true;
  state.isLoading = false;
  state.saving = false;
  state.phone = {};
  state.isUpdating = false;
  state.doNotText = false;
  state.status = candidateStatusTypes.ACTIVE;
  state.defaultChannel = channelTypes.SMS;
  state.currentCandidateCount = 0;
  state.loadingExternalData = false;
  state.loadingICIMSData = false;
  state.icimsIntegrationData = {};
  state.loadingTemplates = true;
  state.hasTemplates = false;
  state.teamTemplates = [];
  state.userTemplates = [];
  state.whatsAppTemplates = [];
};

const getTemplateTypes = (templates) => {
  const userTemplates = [];
  const teamTemplates = [];
  const whatsAppTemplates = [];

  templates.forEach((template) => {
    const code = (template.integrationCode || '').toLowerCase();
    const isTextrecruitCode = code === textrecruit;

    if (isTextrecruitCode || code === ICIMS) {
      teamTemplates.push(template);
    } else if (
      (!isTextrecruitCode && code.includes(`${textrecruit}-`)) ||
      (template.userName && !template.integrationCode && !template.share)
    ) {
      userTemplates.push(template);
    } else if (code === channelTypes.WHATS_APP.toLowerCase()) {
      whatsAppTemplates.push(template);
    } else {
      userTemplates.push(template);
    }
  });

  return { userTemplates, teamTemplates, whatsAppTemplates };
};

const candidatesUploadRejection = (state, action) => {
  state.candidatesUpload.isLoading = false;
  state.candidatesUpload.isError = true;
  state.candidatesUpload.errorMessage = action.payload.message;
};

const candidateSlice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {},

  // eslint-disable-next-line max-statements
  extraReducers: (builder) => {
    builder.addCase(fetchCandidates.pending, (state) => {
      state.isLoading = true;
      state.error = false;
    });

    builder.addCase(fetchCandidates.fulfilled, (state, action) => {
      const { paging = {}, candidates } = action.payload;
      state.candidates = updateCandidateLoop(candidates);
      state.isLoading = false;
      state.page = paging.page;
      state.candidatesCount = paging.items || candidates.length;
      state.error = false;
    });

    builder.addCase(fetchCandidates.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    });

    builder.addCase(searchCandidateOptions.pending, (state) => {
      state.isCandidateOptionsLoading = true;
    });

    builder.addCase(searchCandidateOptions.fulfilled, (state, action) => {
      const { paging = {}, candidates } = action.payload;
      state.candidateOptions = dedupeOptions(state.candidateOptions, candidates);
      state.isCandidateOptionsLoading = false;
      state.candidateOptionsCount = paging.items || state.candidateOptions.length;
    });

    builder.addCase(searchCandidateOptions.rejected, (state, action) => {
      state.isCandidateOptionsLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(resetCandidateOptions, (state) => {
      state.candidateOptions = [];
    });

    builder.addCase(fetchById.pending, (state) => {
      state.isLoading = true;
      state.candidateByIdError = false;
    });

    builder.addCase(fetchById.fulfilled, (state, action) => {
      state.isLoading = false;
      setCandidate(state, action.payload.candidate);
      state.candidateByIdError = false;
    });

    builder.addCase(fetchById.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
      state.candidateByIdError = action.payload.message;
      resetCandidate(state);
    });

    builder.addCase(fetchTagsOptions.pending, (state) => {
      state.isTagsOptionsLoading = true;
    });

    builder.addCase(fetchTagsOptions.fulfilled, (state, action) => {
      const { paging = {}, tags } = action.payload;
      const { resetOptions } = action.meta.arg;

      state.tagsOptions = dedupeOptions(resetOptions ? [] : state.tagsOptions, tags);
      state.isTagsOptionsLoading = false;
      state.tagsOptionsPage = paging.page;
      state.tagsOptionsCount = paging.items || state.tagsOptions.length;
    });

    builder.addCase(fetchTagsOptions.rejected, (state, action) => {
      state.isTagsOptionsLoading = false;
      state.tagsError = action.payload.error;
    });

    builder.addCase(resetTagsOptions, (state) => {
      state.tagsOptions = [];
    });

    builder.addCase(fetchCandidatesCampaignById.pending, (state) => {
      state.candidateCampaign.isLoading = true;
    });

    builder.addCase(fetchCandidatesCampaignById.fulfilled, (state, action) => {
      state.candidateCampaign.isLoading = false;
      state.candidateCampaign.campaigns = action.payload.candidate.jobs || [];
      if (action.payload.candidate.jobs) {
        state.candidateCampaign.campaignsCount = action.payload.candidate.jobs.length;
      }
    });

    builder.addCase(fetchCandidatesCampaignById.rejected, (state, action) => {
      state.candidateCampaign.isLoading = false;
      state.candidateCampaignError = action.payload.error;
    });

    builder.addCase(fetchCandidateMetricsById.pending, (state) => {
      state.candidateMetricsLoading = true;
      state.candidateMetricsError = false;
    });

    builder.addCase(fetchCandidateMetricsById.fulfilled, (state, action) => {
      const [candidateMetrics] = [...action.payload.metrics];
      state.candidateMetrics = candidateMetrics;
      state.candidateMetricsLoading = false;
    });

    builder.addCase(fetchCandidateMetricsById.rejected, (state, action) => {
      state.candidateMetricsLoading = false;
      state.candidateMetricsError = action.payload.error;
    });

    builder.addCase(deleteCandidatesAction.pending, (state) => {
      state.candidateDeleteUpdating = true;
    });

    builder.addCase(deleteCandidatesAction.fulfilled, (state) => {
      state.candidateDeleteUpdating = false;
    });

    builder.addCase(deleteCandidatesAction.rejected, (state, action) => {
      state.candidateDeleteUpdating = false;
      state.deleteCandidatesError = action.payload.error;
    });

    builder.addCase(deleteCandidateTag.pending, (state) => {
      state.candidateTagsUpdating = true;
    });

    builder.addCase(deleteCandidateTag.fulfilled, (state, action) => {
      state.candidateTagsUpdating = false;
      state.fullTags = action.payload.candidate.fullTags;
    });

    builder.addCase(deleteCandidateTag.rejected, (state, action) => {
      state.candidateTagsUpdating = false;
      state.deleteTagError = action.payload.error;
    });

    builder.addCase(addTagForCandidate.pending, (state) => {
      state.candidateTagsUpdating = true;
    });

    builder.addCase(addTagForCandidate.fulfilled, (state, action) => {
      state.candidateTagsUpdating = false;
      state.fullTags = action.payload.candidate.fullTags;
    });

    builder.addCase(addTagForCandidate.rejected, (state, action) => {
      state.candidateTagsUpdating = false;
      state.addTagError = action.payload.error;
    });

    builder.addCase(updateChannel.pending, (state) => {
      state.isChannelUpdating = true;
    });

    builder.addCase(updateChannel.fulfilled, (state, action) => {
      state.isChannelUpdating = false;
      state.defaultChannel = action.payload.candidate.channel;
    });

    builder.addCase(updateChannel.rejected, (state) => {
      state.isChannelUpdating = false;
    });

    builder.addCase(fetchICIMSData.pending, (state) => {
      state.loadingICIMSData = true;
    });

    builder.addCase(fetchICIMSData.fulfilled, (state, action) => {
      const { integrationData } = action.payload;

      if (
        // eslint-disable-next-line no-prototype-builtins
        !action.payload.hasOwnProperty('$$hashKey') ||
        (integrationData && Object.keys(integrationData).length)
      ) {
        state.icimsIntegrationData = integrationData;
      }
      state.loadingICIMSData = false;
    });

    builder.addCase(fetchICIMSData.rejected, (state, action) => {
      state.loadingICIMSData = false;
      state.icimsIntegrationData = {};
      state.error = action.payload.error;
    });

    builder.addCase(fetchAllTemplates.pending, (state) => {
      state.loadingTemplates = true;
    });

    builder.addCase(fetchAllTemplates.fulfilled, (state, action) => {
      const templates = action.payload.templates || [];
      const { userTemplates, teamTemplates, whatsAppTemplates } = getTemplateTypes(templates);

      state.loadingTemplates = false;
      state.hasTemplates = Boolean(
        userTemplates.length + teamTemplates.length + whatsAppTemplates.length,
      );
      state.userTemplates = userTemplates;
      state.teamTemplates = teamTemplates;
      state.whatsAppTemplates = whatsAppTemplates;
    });

    builder.addCase(fetchAllTemplates.rejected, (state, action) => {
      state.loadingTemplates = false;
      state.error = action.payload.message;
    });

    builder.addCase(addCandidate.pending, (state) => {
      state.savingCandidate = true;
      state.candidateSaved = false;
    });

    builder.addCase(addCandidate.fulfilled, (state, action) => {
      state.savingCandidate = false;
      state.candidateSaved = true;
      setCandidate(state, action.payload.candidate);
    });

    builder.addCase(addCandidate.rejected, (state, action) => {
      state.savingCandidate = false;
      state.candidateSaved = false;
      state.error = action.payload.error;
    });

    builder.addCase(updateCandidate.pending, (state) => {
      state.savingCandidate = false;
      state.candidateUpdated = true;
    });

    builder.addCase(updateCandidate.fulfilled, (state, action) => {
      state.savingCandidate = false;
      state.candidateUpdated = true;
      setCandidate(state, action.payload.candidate);
    });

    builder.addCase(updateCandidate.rejected, (state, action) => {
      state.savingCandidate = false;
      state.candidateUpdated = false;
      state.error = action.payload.error;
    });

    builder.addCase(resetCandidateSave, (state) => {
      state.savingCandidate = false;
      state.candidateSaved = false;
      state.candidateUpdated = false;
    });

    builder.addCase(fetchCandidateScheduledMessages.pending, (state) => {
      state.scheduledMessages.isLoading = true;
    });

    builder.addCase(fetchCandidateScheduledMessages.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;
      state.scheduledMessages.messages = action.payload.messages || [];
      state.scheduledMessages.isLoading = false;
      state.scheduledMessages.page = page;
      state.scheduledMessages.count = items;
    });

    builder.addCase(fetchCandidateScheduledMessages.rejected, (state, action) => {
      state.scheduledMessages.isLoading = false;
      state.scheduledMessages.error = action.payload.error;
    });

    builder.addCase(updateInactiveCandidate.pending, (state) => {
      state.candidateStatusUpdated = false;
    });

    builder.addCase(updateInactiveCandidate.fulfilled, (state, action) => {
      setCandidate(state, action.payload.candidate);
      state.candidateStatusUpdated = true;
    });

    builder.addCase(updateInactiveCandidate.rejected, (state, action) => {
      state.scheduledMessages.error = action.payload.error;
      state.candidateStatusUpdated = false;
    });

    builder.addCase(updateStarredCandidate.pending, (state) => {
      state.starredCandidateUpdated = false;
    });

    builder.addCase(updateStarredCandidate.fulfilled, (state, action) => {
      setCandidate(state, action.payload.candidate);
      state.starredCandidateUpdated = true;
    });

    builder.addCase(updateStarredCandidate.rejected, (state, action) => {
      state.starredCandidateUpdated = false;
      state.scheduledMessages.error = action.payload.error;
    });

    builder.addCase(updateArchiveCandidate.pending, (state) => {
      state.candidateStatusUpdated = false;
    });

    builder.addCase(updateArchiveCandidate.fulfilled, (state, action) => {
      setCandidate(state, action.payload.candidate);
      state.candidateStatusUpdated = true;
    });

    builder.addCase(updateArchiveCandidate.rejected, (state, action) => {
      state.candidateStatusUpdated = false;
      state.scheduledMessages.error = action.payload.error;
    });

    builder.addCase(updateAllActiveCandidate.pending, (state) => {
      state.candidateStatusUpdated = false;
    });

    builder.addCase(updateAllActiveCandidate.fulfilled, (state, action) => {
      setCandidate(state, action.payload.candidate);
      state.candidateStatusUpdated = true;
    });

    builder.addCase(updateAllActiveCandidate.rejected, (state, action) => {
      state.candidateStatusUpdated = false;
      state.scheduledMessages.error = action.payload.error;
    });

    builder.addCase(updateDoNotTextCandidate.fulfilled, (state) => {
      state.doNotText = true;
    });

    builder.addCase(updateDoNotTextFlag, (state, action) => {
      if (state.id === action.payload.candidateId) {
        let shouldNotText = state.doNotText;
        const messageText = action.payload.messageText || '';
        if (action.payload.doNotTextFlag) {
          shouldNotText = true;
        } else if (messageText.toLowerCase() === resubscribeMesssage) {
          shouldNotText = false;
        }
        state.doNotText = shouldNotText;
      }
    });

    builder.addCase(resetIsCancelMessageSuccess, (state) => {
      state.isCancelMessage = false;
      state.isCancelMessageSuccess = false;
    });

    builder.addCase(resetCandidateUpdatedFlag, (state) => {
      state.starredCandidateUpdated = false;
    });

    builder.addCase(resetImportModalSuccessFlag, (state) => {
      state.candidatesUpload.isImportSuccess = false;
    });

    builder.addCase(addAtsCandidateSuccess, (state, action) => {
      state.selectedAtsIdsCount = action.payload.selectedIdsCount;
      state.atsCandidatesSaved = action.payload.atsCandidateSaved;
    });

    builder.addCase(updateAtsCandidateSavedStatus, (state) => {
      state.atsCandidateSaved = false;
    });

    builder.addCase(setCandidateSaved, (state) => {
      state.candidateSaved = false;
    });

    builder.addCase(validateCandidate.pending, (state) => {
      state.candidateValidationLoading = true;
    });

    builder.addCase(validateCandidate.fulfilled, (state, action) => {
      state.candidateValidationLoading = false;
      setCandidate(state, action.payload.candidate);
    });

    builder.addCase(validateCandidate.rejected, (state) => {
      state.candidateValidationLoading = false;
    });

    builder.addCase(fetchNumberCandidatesWithTags.pending, (state) => {
      state.candidateWithTagsLoading = true;
    });

    builder.addCase(fetchNumberCandidatesWithTags.fulfilled, (state, action) => {
      state.candidateWithTagsLoading = false;
      state.candidatesNumberWithTags = action.payload.candidates.length;
    });

    builder.addCase(fetchNumberCandidatesWithTags.rejected, (state, action) => {
      state.candidateWithTagsLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(candidatesUpload.pending, (state) => {
      state.candidatesUpload.isLoading = true;
      state.candidatesUpload.isError = false;
      state.candidatesUpload.uploadHeaders = [];
    });

    builder.addCase(candidatesUpload.fulfilled, (state, action) => {
      state.candidatesUpload.isLoading = false;
      state.candidatesUpload.isError = false;
      state.candidatesUpload.uploadHeaders = action.payload.headers || [];
      state.candidatesUpload.isUploaded = Boolean(action.payload.headers.length);
      state.candidatesUpload.rowCount = action.payload.rowCount;
    });

    builder.addCase(candidatesUpload.rejected, (state, action) => {
      candidatesUploadRejection(state, action);
    });

    builder.addCase(candidatesImport.pending, (state) => {
      state.candidatesUpload.isLoading = true;
      state.candidatesUpload.isError = false;
      state.candidatesUpload.isImportSuccess = false;
    });

    builder.addCase(candidatesImport.fulfilled, (state, action) => {
      state.candidatesUpload.isLoading = false;
      state.candidatesUpload.isUploaded = false;
      state.candidatesUpload.isImportSuccess = Boolean(action.payload.backgroundEventId);
    });

    builder.addCase(candidatesImport.rejected, (state, action) => {
      state.candidatesUpload.isUploaded = false;
      candidatesUploadRejection(state, action);
    });

    builder.addCase(resetIsError, (state) => {
      state.candidatesUpload.isError = false;
    });

    builder.addCase(removeSelectedCampaign.pending, (state) => {
      state.candidateCampaignUpdating = true;
    });

    builder.addCase(removeSelectedCampaign.fulfilled, (state, action) => {
      state.candidateCampaignUpdating = true;
      state.jobs = action.payload.jobs;
    });

    builder.addCase(removeSelectedCampaign.rejected, (state, action) => {
      state.candidateCampaignUpdating = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchOmniSearch.pending, (state) => {
      state.omniSearchLoading = true;
    });

    builder.addCase(fetchOmniSearch.fulfilled, (state, action) => {
      const { results } = action.payload;
      state.omniSearchLoading = false;
      state.omniSearchList = results;
    });

    builder.addCase(fetchOmniSearch.rejected, (state, action) => {
      state.omniSearchLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(cancelScheduledMessages.pending, (state) => {
      state.isCancelMessage = false;
    });

    builder.addCase(cancelScheduledMessages.fulfilled, (state, action) => {
      state.isCancelMessage = true;
      state.isCancelMessageSuccess = Boolean(action.payload.schedule);
    });

    builder.addCase(cancelScheduledMessages.rejected, (state, action) => {
      state.isCancelMessage = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchCandidatesInSequence.pending, (state) => {
      state.candidatesInSequenceLoading = true;
    });

    builder.addCase(fetchCandidatesInSequence.fulfilled, (state, action) => {
      state.candidatesInSequenceLoading = false;
      state.candidatesInSequence = action.payload.candidatesInSequence;
    });

    builder.addCase(fetchCandidatesInSequence.rejected, (state, action) => {
      state.candidatesInSequenceLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchATSCandidates.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchATSCandidates.fulfilled, (state, action) => {
      const { paging = {}, candidates } = action.payload;
      state.atsCandidatesCount = paging.items;
      state.candidates = updateCandidateLoop(candidates || []);
      state.isLoading = false;
      state.page = paging.page;
    });

    builder.addCase(fetchATSCandidates.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(addATSCandidate.pending, (state) => {
      state.isLoading = true;
      state.atsCandidateSaved = false;
    });

    builder.addCase(addATSCandidate.fulfilled, (state) => {
      state.isLoading = false;
      state.atsCandidateSaved = true;
    });

    builder.addCase(addATSCandidate.rejected, (state) => {
      state.isLoading = false;
      state.atsCandidateSaved = false;
    });

    builder.addCase(resetCandidateUpdated, (state) => {
      state.candidateUpdated = false;
    });

    builder.addCase(fetchBackgroundEvents.fulfilled, (state, action) => {
      const events = action.payload.events || [];
      if (events.length && events[0].type === backgroundEventTypes.CANDIDATE_IMPORT) {
        commonStateUpdates(state, action);
      }
    });
  },
});

export default candidateSlice;
